"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@umich-lib/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getButtonColor(kind) {
  switch (kind) {
    case 'primary':
      return _styles.COLORS.maize;

    case 'secondary':
    case 'tertiary':
      return _styles.COLORS.teal;

    default:
      return _styles.COLORS.blue;
  }
}

function getButtonKindCSS(kind, color) {
  switch (kind) {
    case 'tertiary':
      return {
        background: 'white',
        padding: "calc(".concat(_styles.SPACING['XS'], " - 1px) calc(").concat(_styles.SPACING['M'], " - 1px)"),
        border: "solid 1px ".concat(color['400']),
        color: color['400'],
        ':hover': {
          outline: "solid 1px ".concat(color['400']),
          outlineOffset: '-2px'
        }
      };

    case 'subtle':
      return {
        background: _styles.COLORS.neutral['100'],
        ':hover': {
          background: _styles.COLORS.blue['200']
        }
      };

    case 'reset':
      return {};

    default:
      return {
        background: color['400'],
        ':hover': {
          background: color['500']
        }
      };
  }
}

function getDisabledCSS(disabled) {
  if (disabled) {
    return {
      opacity: '0.5',
      ":hover": {},
      cursor: 'not-allowed'
    };
  }

  return {};
}

function getButtonCSS(kind, disabled) {
  var color = getButtonColor(kind);

  if (kind === 'reset') {
    return {};
  }

  return _objectSpread({
    display: 'flex',
    alignItems: 'center',
    borderRadius: '2px',
    minHeight: '2.5rem',
    padding: "".concat(_styles.SPACING['XS'], " ").concat(_styles.SPACING['M']),
    color: (0, _styles.lightOrDark)(color['400']) === 'light' || kind === 'subtle' ? 'inherit' : 'white',
    fontWeight: '800'
  }, getButtonKindCSS(kind, color, disabled), {
    ':focus': {
      outline: 'none',
      boxShadow: "0 0 0 3px #ffffff, 0 0 0 4px ".concat(_styles.COLORS.neutral['400'])
    }
  }, getDisabledCSS(disabled));
}
/**
 * Use buttons to move though a transaction, aim to use only one primary button per page.
 */


var Button = function Button(_ref) {
  var kind = _ref.kind,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["kind", "disabled"]);

  return (0, _core.jsx)("button", _extends({
    css: getButtonCSS(kind, disabled)
  }, rest));
};

Button.propTypes = {
  kind: _propTypes["default"].oneOf(['primary', 'secondary', 'tertiary', 'subtle', 'reset']).isRequired
};
Button.defaultProps = {
  kind: 'secondary'
};
var _default = Button;
exports["default"] = _default;